<template>
  <div class="streaming-card">
    <div class="release-info">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <div class="d-flex align-items-center">
          <div class="title mr-3">
            {{ $t('servers.releaseInformation') }}
          </div>
          <Label :class="item.status.toLowerCase()">{{
            $t(`filters.${item.status.toLowerCase()}`)
          }}</Label>
        </div>
        <div>
          <b-button variant="filter-success" class="rounded-sm">
            <i class="fal fa-copy copyIcon"> </i>
            {{ $t('servers.copyEmbedCode') }}</b-button
          >
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-5">
        <div class="d-flex align-items-center">
          <div
            class="subTitleIcon mr-3 d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-video"></i>
          </div>
          <div class="subTitle">
            {{ $t('servers.releaseInformation') }}
          </div>
        </div>
        <div>N/A</div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-5">
        <div class="d-flex align-items-center">
          <div
            class="subTitleIcon mr-3 d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-stream"></i>
          </div>
          <div class="subTitle">
            {{ $t('servers.broadcastQuality') }}
          </div>
        </div>
        <div v-if="item.status == 'active'">
          {{ $t('servers.broadcastAnalysisInProgress') }}
        </div>
        <div v-else>-</div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-5">
        <div class="d-flex align-items-center">
          <div
            class="subTitleIcon mr-3 d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-users"></i>
          </div>
          <div class="subTitle">
            {{ $t('servers.broadcastStartTime') }}
          </div>
        </div>
        <div>
          {{
            $customFunctions.setMomentWithFormat(
              item.started_at,
              'DD.MM.yyyy HH:mm'
            ) || '-'
          }}
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-5">
        <div class="d-flex align-items-center">
          <div
            class="subTitleIcon mr-3 d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-clock"></i>
          </div>
          <div class="subTitle">
            {{ $t('servers.releaseTime') }}
          </div>
        </div>
        <div>
          {{ calcReleaseTime() }}
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div
            class="subTitleIcon mr-3 d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-stream"></i>
          </div>
          <div class="subTitle">
            {{ $t('servers.broadcastEndTime') }}
          </div>
        </div>
        <div>
          {{
            $customFunctions.setMomentWithFormat(
              item.ended_at,
              'DD.MM.yyyy HH:mm'
            ) || '-'
          }}
        </div>
      </div>
    </div>
    <div class="stream-info">
      <div class="title mb-5">
        {{ $t('servers.streamInformation') }}
      </div>

      <div class="formTitle mb-1">
        {{ $t('servers.streamName') }}
      </div>
      <div class="align-items-top formArea">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
          </template>
          <div>
            <Input
              placeholder="servers.streamName"
              :defaultValue="item.name"
              id="name"
              v-model="form.name"
              :state="validateState('name')"
            />
          </div>
          <div>
            <b-button
              type="submit"
              class="w-100 rounded-sm"
              variant="primary"
              @click="confirm"
              ref="submitButton"
              >{{ $t('global.save') }}</b-button
            >
          </div>
        </b-skeleton-wrapper>
      </div>

      <div class="d-flex align-items-center mb-5">
        <div class="subTitle mr-3 col-4">
          {{ $t('servers.streamKey') }}
        </div>
        <div class="col-8">
          {{ getStreamKey() }}
        </div>
      </div>
      <div class="d-flex align-items-center mb-5">
        <div class="subTitle mr-3 col-4">
          {{ $t('servers.streamUrl') }}
        </div>
        <div class="col-8">
          {{ item.stream_url }}
        </div>
      </div>
      <div class="d-flex align-items-center mb-5">
        <div class="subTitle mr-3 col-4">
          {{ $t('servers.publishUrl') }}
        </div>
        <div class="col-8">
          {{ item.publish_url }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="subTitle mr-3 col-4">
          {{ $t('servers.publicKey') }}
        </div>
        <div class="col-8">
          {{ item.public_key }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  props: ['item'],
  mixins: [validationMixin],
  name: 'StreamCard',
  data() {
    return {
      form: {
        name: '',
      },
      loading: false,
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.loading = true

      let params = {
        name: this.form.name,
      }
      ApiService.put(`streaming/stream/${this.$route.params.id}`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$v.$reset()
          this.item.name = this.form.name
          this.loading = false
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.loading = false
        })
    },
    calcReleaseTime() {
      if (this.item.started_at && this.item.ended_at) {
        return moment
          .utc(
            moment(this.item.started_at, 'YYYY-MM-DDTHH:mm:ss').diff(
              moment(this.item.ended_at, 'YYYY-MM-DDTHH:mm:ss')
            )
          )
          .format('HH:mm:ss')
      }
      return '-'
    },
    getStreamKey() {
      if (this.item.stream_url) {
        let splt = this.item.stream_url.split('/')
        if (splt.length > 1) {
          return splt[splt.length - 1]
        }
      }
      return '-'
    },
  },
}
</script>

<style lang="scss" scoped>
.streaming-card {
  background: #0a1f44;
  border-radius: 12px;
  padding: 20px;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 40px;
  .release-info {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #4a4b68;
    .title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #4a4b68;
    }
    .copyIcon {
      font-size: 12px;
      line-height: 12px;
      color: #ffffff;
    }
    .subTitle {
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      color: #b5b5c3;
    }
    .subTitleIcon {
      background: #00baf2;
      border-radius: 100px;
      height: 32px;
      width: 32px;
      i {
        font-weight: 900;
        font-size: 12px;
        line-height: 12px;
        color: #ffffff;
      }
    }
  }
  .stream-info {
    .title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #ffffff;
    }
    .subTitle {
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: #8b959c;
    }
    .formTitle {
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 19px;
      color: #b5b5c3;
    }
    .formArea {
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 20px;
    }
  }
}
</style>
